import {
    GET_CART_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CART_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                cartDetails: action.cartDetails
                
            }
        default:
            return state
    }
}